import React, { useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import withFluidWrapper from "../Section/withFluidWrapper";

const Container = styled.header`
  ${(p) => p.theme.minHeight && `min-height: ${p.theme.minHeight}`};
  ${(p) => p.theme.height && `height: ${p.theme.height}`};
  ${(p) => p.theme.maxHeight && `max-height: ${p.theme.maxHeight}`};
  ${(p) => !p.noInlineCSS && p.inlineCSS}
`;

const Section = ({ extra, children, noInlineCSS = false }) => {
  const { style = {}, className } = extra;

  return (
    <ThemeProvider theme={style}>
      <Container
        noInlineCSS={noInlineCSS}
        inlineCSS={extra.css}
        className={
          extra.withFluidWrapper
            ? `container-fluid px-0 ${className ? className : ""}`
            : `container ${className ? className : ""}`
        }
      >
        {children}
      </Container>
    </ThemeProvider>
  );
};

export default withFluidWrapper(Section);
